import { LoginModel } from '../models/login-model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
//import {Response, RequestOptions, Headers } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';  
import { Observable } from 'rxjs';  
import { environment } from '../../../../environments/environment';
import {UserConfig} from '../models/userconfig';
@Injectable({
  providedIn: 'root'
})
export class LoginServiceService {

  base_url = environment.apiUrl;
  loginModel : LoginModel;
  constructor(private http: HttpClient) { }  
  httpOptions = {
    headers: new HttpHeaders({
      'No-Auth':  'True'
    })
  };
  AuthenticateUser(login : LoginModel):Observable<UserConfig> {    
    return this.http.post<UserConfig>(this.base_url + "Login",login, this.httpOptions)
  }

  SetToken(token : string):Observable<string> {    
    let params = new HttpParams().set("token", token); //Create new HttpParams
    return this.http.get<string>(this.base_url + "Login", {params: params});
  }

  getAllRoles() {
    //var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    //return this.http.get(this.rootUrl + '/api/GetAllRoles', { headers: reqHeader });
  }

  isTrHomePage(destination:string)
  {
      if(destination=='etm-dashboard')
      {
        var userconfig = JSON.parse(localStorage.getItem('userconfig'));
        if(userconfig) 
        {
          if(userconfig.AppModuleType==1)
            {
              return true;    
            }
        }
      }
      return false;
  }
  roleMatch(allowedRoles, destination:string): boolean {
    var isMatch = false;
    var userconfig = JSON.parse(localStorage.getItem('userconfig'));
    if(!userconfig) 
    {
      //console.log('T10 case');
      return false;    
    }
    var userRoles= userconfig.Roles; //JSON.parse(localStorage.getItem('userRoles'));
    //console.log(userRoles);
    allowedRoles.forEach(element => {      
      let obj = userRoles.find(o => 
        {           
          if (o.Name === element) {
            isMatch = true;
            return true;
          }          
        });      
      //if (userRoles.indexOf(element) > -1) {
      //  isMatch = true;
      //  return true;
      //}
    });
    isMatch = this.appModuleMatch(destination, userconfig.AppModuleType, isMatch);
    return isMatch;

  }
  appModuleMatch(destination:string, appModuleType: number, isMatch:boolean)
  {    
    let tr_routes = ['trcheckin','reportattending',
                    'class-input','class-manager',
                    'traineeclass-manager', 'schedule-manager'
                    ];
    let pr_routes = ['car-map', 'car-map-online' ];
    if (appModuleType==1)
    {        
        if(pr_routes.indexOf(destination)>-1)
        {
          return false;
        }
    }
    else if(appModuleType==2)
    {
        if(tr_routes.indexOf(destination)>-1)
        {
            return false;
        }
    }
    return isMatch;
  }
}